import { API_BASE_URL } from "./api";

const USER_KEY = "user";
const TOKEN_KEY = "token";
const REFRESH_TOKEN_KEY = "refreshToken";

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function getRefreshToken() {
  return localStorage.getItem(REFRESH_TOKEN_KEY);
}

export function getUser() {
  try {
    const raw = localStorage.getItem(USER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

function notify(){ window.dispatchEvent(new Event('authChanged')); }

export function setSession({ user, accessToken, refreshToken }) {
  if (accessToken) localStorage.setItem(TOKEN_KEY, accessToken);
  if (refreshToken) localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
  if (user) localStorage.setItem(USER_KEY, JSON.stringify(user));
  notify();
}

export function clearSession() {
  localStorage.removeItem(USER_KEY);
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
  notify();
}

export function isLoggedIn() {
  return !!getToken() && !!getUser();
}

// Decode the JWT exp claim and return the expiry as a ms timestamp.
// Returns null if no token, malformed payload, or exp is absent.
export function getTokenExpiry() {
  const token = getToken();
  if (!token) return null;
  try {
    const part = token.split('.')[1];
    if (!part) return null;
    // base64url → base64 (replace chars, restore padding)
    const b64 = part.replace(/-/g, '+').replace(/_/g, '/') +
      '==='.slice(0, (4 - part.length % 4) % 4);
    const payload = JSON.parse(atob(b64));
    return typeof payload.exp === 'number' ? payload.exp * 1000 : null;
  } catch {
    return null;
  }
}

// Optional helper if you want to show this somewhere
export function getApiBase() {
  return API_BASE_URL;
}
